export const getUrlParam = function (paraName) {
    let url = document.location.toString();
    if (url.indexOf("#/") >= 0) {
        url = url.split("#/");
    } else {
        url = [url];
    }
    let attrs = [];
    url.map(function (item) {
        if (item.indexOf("?") >= 0) {
            attrs.push(item.split("?")[1]);
        }
    });
    attrs = attrs.join("&");
    const arrPara = attrs.split("&");
    let arr;
    for (let i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split("=");
        if (arr != null && arr[0] == paraName) {
            return decodeURIComponent(arr[1]);
        }
    }

    return "";
};

export const href = function (route) {
    if (route) {
        let baseUrl = window.location.pathname; //'/';
        //if (process.env.NODE_ENV !== 'development') {
        //  baseUrl = '/wap/';
        //}
        console.log(route);
        if (route === "/") {
            window.location.href = baseUrl;
        } else {
            window.location.href =
                route.indexOf("#") === 0
                    ? baseUrl + route
                    : baseUrl + "#" + route;
        }
    }
};

export const encode = function (str) {
    // 对字符串进行编码
    var encode = encodeURI(str);
    // 对编码的字符串转化base64
    var base64 = window.btoa(encode);
    return base64;
};

export const decode = function (base64) {
    // 对base64转编码
    var decode = window.atob(base64);
    // 编码转字符串
    var str = decodeURI(decode);
    return str;
};

export const versionStringCompare = function (
    prerVersion = "",
    lastVersion = ""
) {
    var sources = prerVersion.split(".");
    var dests = lastVersion.split(".");
    var maxL = Math.max(sources.length, dests.length);
    var result = 0;
    for (let i = 0; i < maxL; i++) {
        let preValue = sources.length > i ? sources[i] : 0;
        let preNum = isNaN(Number(preValue))
            ? preValue.charCodeAt()
            : Number(preValue);
        let lastValue = dests.length > i ? dests[i] : 0;
        let lastNum = isNaN(Number(lastValue))
            ? lastValue.charCodeAt()
            : Number(lastValue);
        if (preNum < lastNum) {
            result = -1;
            break;
        } else if (preNum > lastNum) {
            result = 1;
            break;
        }
    }
    return result;
};

export const viewPort = function () {
    let u = navigator.userAgent.toLowerCase();
    return {
        isWeixin:
            u.indexOf("micromessenger") > -1 ||
            u.match(/weixin*/i) ||
            u.match(/wechat*/i),
        isQQ: u.indexOf("qq/") > -1,
        trident: u.indexOf("trident") > -1, //IE内核
        presto: u.indexOf("presto") > -1, //opera内核
        webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
        gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
        mobile: !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
        android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
        iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("ipad") > -1, //是否iPad
        webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
        isHlApp: u.match(/huilian*/i), //是否远程慧联app
    };
};

export const getUrlParams = () => {
    var obj = "",
        obj1 = "",
        ops = {};
    if (window.location.hash.indexOf("?") > -1) {
        obj = window.location.hash.split("?")[1];
        obj1 = obj.split("&");
        for (var i = 0; i < obj1.length; i++) {
            ops[obj1[i].split("=")[0]] =
                obj1[i].split("=")[1] === "undefined"
                    ? ""
                    : obj1[i].split("=")[1];
        }
    }
    return ops;
};



// WEBPACK FOOTER //
// ./src/utils/util.js